import { Heading, Paragraph } from "@/components/ui/Typography"
import { WebsitePageSection } from "@/types"
import EditableSection from "@/components/admin/Content/WebPages/EditableSection";
import { Check } from "lucide-react";


const WhatWeOffer = ({data}:{data: WebsitePageSection}) => {
  return (
    <EditableSection
      sectionTag={data.sectionTag}
      // contentType={"WITH_LIST"}
      contentType={data.contentType}
      data={data}
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-4 ">
          <Paragraph className=" py-1 px-3 flex items-center justify-center !text-sm bg-wine-100 rounded-2xl text-white w-fit">What We Offer</Paragraph>
        </div>

        <Heading className="" level={3} >{data.sectionTitle ?? "Default Title"}</Heading>
        {/* <Paragraph className="">{data.description ?? ""}</Paragraph> */}

        <ul className="flex flex-col gap-4 list-none ">
          { Array.isArray(data.listOfPurpose) &&
            data.listOfPurpose.map((item, index) => (
              <li key={index} className="grid grid-cols-[1.5rem_1fr] items-start gap-2">
                <Check className="rounded-full bg-forestGreen-100 text-white p-1" size={24} />
                <Paragraph className="">{item}</Paragraph>
              </li>
            ))
          }
        </ul>
      </div>
    </EditableSection>
  )
}

export default WhatWeOffer